import React, {
    useState,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
} from "react-icons/fa";

const Contact = () => {
    const [open, setOpen] =
        useState(false);

    return (
        <>
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <section className="w-full bg-[#f7f9fc] overflow-x-hidden">

                {/* HERO */}
                <div className="bg-gradient-to-r from-[#072F5F] to-[#0B4F9C] py-16 md:py-20">

                    <div className="max-w-7xl mx-auto px-5 md:px-10 text-center">

                        <span className="text-[#D4A017] uppercase tracking-[4px] text-xs md:text-sm font-semibold">

                            Contact Us

                        </span>

                        <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-4">

                            Get In Touch

                        </h1>

                        <p className="text-gray-200 text-base md:text-lg mt-5 max-w-3xl mx-auto leading-8">

                            We are always happy to hear from parents,
                            students and visitors. Reach out to us for
                            admissions, inquiries or any assistance.

                        </p>

                    </div>

                </div>

                {/* MAIN CONTENT */}
                <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">

                    {/* CONTACT CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                        {/* ADDRESS */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            {/* ICON */}
                            <div className="w-14 h-14 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-lg shrink-0">

                                <FaMapMarkerAlt />

                            </div>

                            {/* CONTENT */}
                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Address

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 leading-7 text-[15px]">

                                    St. Joseph's School, Chowk Road,
                                    Maharajganj U.P.(273303)

                                </p>

                            </div>

                        </div>

                        {/* PHONE */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            {/* ICON */}
                            <div className="w-14 h-14 rounded-xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-lg shrink-0">

                                <FaPhoneAlt />

                            </div>

                            {/* CONTENT */}
                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Call Us

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 text-[17px] font-medium">

                                    Phone:05523-222661
                                    Mobile:+917398973880

                                </p>

                            </div>

                        </div>

                        {/* EMAIL */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            {/* ICON */}
                            <div className="w-14 h-14 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-lg shrink-0">

                                <FaEnvelope />

                            </div>

                            {/* CONTENT */}
                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Email

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 text-[15px] break-all leading-7">

                                   sjsmrj@yahoo.com

                                </p>

                            </div>

                        </div>

                    </div>

                    {/* FORM + MAP */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-16">

                        {/* FORM */}
                        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-10 border border-gray-100">

                            <h2 className="text-3xl md:text-4xl font-extrabold text-[#072F5F] mb-8">

                                Send Us a Message

                            </h2>

                            <div className="space-y-5">

                                <input
                                    type="text"
                                    placeholder="Your Name"
                                    className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-[#0B4F9C]"
                                />

                                <input
                                    type="email"
                                    placeholder="Your Email"
                                    className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-[#0B4F9C]"
                                />

                                <textarea
                                    placeholder="Your Message"
                                    rows="6"
                                    className="w-full border border-gray-200 rounded-xl px-5 py-4 outline-none focus:ring-2 focus:ring-[#0B4F9C]"
                                ></textarea>

                                <button className="bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-lg">

                                    Send Message

                                </button>

                            </div>

                        </div>

                        {/* MAP */}
                        <div className="overflow-hidden rounded-3xl shadow-xl min-h-[450px] border border-gray-100">

                            <iframe
                                title="ST JOSEPH SCHOOL MAP"
                                src="https://maps.google.com/maps?q=ST.%20JOSEPH'S%20SCHOOL%20Maharajganj&t=&z=17&ie=UTF8&iwloc=&output=embed"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                loading="lazy"
                                allowFullScreen=""
                                referrerPolicy="no-referrer-when-downgrade"
                                className="min-h-[450px] w-full"
                            ></iframe>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />
        </>
    );
};

export default Contact;